import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { TimerService } from "@app/pages/timer-home-page/timer-calendar-view.service";
import { CalendarDayViewModel, CalendarEnabledTimes } from "../timer-calendar-view.models";

@Component({
	selector: "app-calendar-day-sidebar",
	templateUrl: "./calendar-day-sidebar.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: "block h-full min-h-0 w-full" },
})
export class CalendarDaySidebarComponent {
	@Input({ required: true }) day!: CalendarDayViewModel;
	@Input({ required: true }) enabledTimes!: CalendarEnabledTimes;

	@Output() createProject = new EventEmitter<void>();
	@Output() projectRowToggle = new EventEmitter<void>();
	@Output() createWorking = new EventEmitter<void>();
	@Output() createAbsence = new EventEmitter<void>();
	constructor(private calendarService: TimerService) {}

	readonly workinghoursCanCreateAbsences$ = this.calendarService.workinghoursCanCreateAbsences.asObservable();
	readonly workinghoursCanCreate$ = this.calendarService.workinghoursCanCreate.asObservable();
}
